import GenericTableTile from "web/components/Tiles/TableTiles/GenericTableTile"
import { useTile } from "web/hooks/data"
import { TileTableSettingsModal } from "../Modal/TileTableSettingsModal"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"

export default function OverviewTableTileWrapper({
  canEdit,
  isTemplate,
  overview,
  tileFetchParams,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileTableSettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  return (
    <GenericTableTile
      canEdit={canEdit}
      id={tileFetchParams.id}
      isTemplate={isTemplate}
      tile={tile}
      tileSettingsModal={tileSettingsModal}
    />
  )
}
